import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { finalize } from 'rxjs';
import { ChopMesskriterium } from '@entity/chop';
import { ChopService } from '@service/chop.service';
import { FormButtonBarComponent } from '@shared/form-button-bar/form-button-bar.component';
import { FormNumberInputComponent } from '@shared/form-number-input/form-number-input.component';

@Component({
  selector: 'app-chop-messkriterium-dialog',
  templateUrl: './chop-messkriterium-dialog.component.html',
  styleUrls: ['./chop-messkriterium-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, FormNumberInputComponent, FormButtonBarComponent],
})
export class ChopMesskriteriumDialogComponent {
  private formBuilder = inject(FormBuilder);
  private dialogConfig = inject(DynamicDialogConfig);
  private dialogRef = inject(DynamicDialogRef);
  private chopService = inject(ChopService);
  private messageService = inject(MessageService);
  private translateService = inject(TranslateService);

  private profilId: number = this.dialogConfig.data.profilId;
  private messkriterium: ChopMesskriterium | undefined = this.dialogConfig.data.messkriterium;
  form = this.formBuilder.group({
    mindestAnzahl: [this.messkriterium?.mindestAnzahl as number | null],
    mindestMinutenProTag: [this.messkriterium?.mindestMinutenProTag as number | null],
    mindestMinutenProDurchfuehrung: [this.messkriterium?.mindestMinutenProDurchfuehrung as number | null],
  });
  submitting = false;

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.submitting = true;
    const value = this.form.getRawValue() as ChopMesskriterium;
    const action = this.messkriterium
      ? this.chopService.updateMesskriterium(this.messkriterium.id, { ...this.messkriterium, ...value })
      : this.chopService.createMesskriterium(this.profilId, value);
    action.pipe(finalize(() => (this.submitting = false))).subscribe({
      next: (result) => this.dialogRef.close(result),
      error: (err) =>
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('GLOBAL.NOT_SUCCESSFULLY_SAVED'),
          detail: err?.error?.message,
        }),
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
